




















import VueOptions from '@utils/VueOptions'

settings =
  name: 'OrganizerInvitationResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    methods:
      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
